import React, { useState, useEffect, useRef, useContext } from "react";
import Lottie from "lottie-web";
import AuthContext from "../../../context/userAuth.context";

const PandS_loader = ({
  setLoadCounter,
  value,
  onePxEquivalent,
  CanvasDisplay,
  TickerPosition,
}) => {
  const { authenticationData } = useContext(AuthContext);

  const AnimationRef = useRef(null);

  const [AnimationData, setAnimationData] = useState(null);

  const [played, setplayed] = useState(false);

  useEffect(() => {
    if (AnimationData) {
      if (sessionStorage.getItem("LoadCounter")) {
        let array = JSON.parse(sessionStorage.getItem("LoadCounter"));
        array.push(value.previewKey);
        sessionStorage.setItem("LoadCounter", JSON.stringify(array));
        setLoadCounter(array);
      }
    }
  }, [AnimationData]);

  useEffect(() => {
    const ctx = AnimationRef.current.getContext("2d");
    const getter = Lottie.loadAnimation({
      name: value.AnimationId,
      renderer: "canvas",
      loop: true,
      autoplay: false,
      path: authenticationData.ApiBaseURL + "/" + value.AnimationPath,
      rendererSettings: {
        context: ctx,
        clearCanvas: true,
        preserveAspectRatio: "xMidYMid meet",
      },
    });
    setAnimationData(getter);
    setplayed(true);
  }, [value.AnimationPath]);

  useEffect(() => {
    if (AnimationData != null) {
      if (
        value.startPositionOnTimeline <= TickerPosition &&
        value.startPositionOnTimeline + value.widthOnTimeline >= TickerPosition
      ) {
        let playedtime = TickerPosition - value.startPositionOnTimeline; //in px
        let jsonTotaltime = AnimationData.totalFrames;
        let fm = AnimationData.frameRate;
        let ms = (playedtime * onePxEquivalent) / 1000;
        let playedFrame = ms * fm;
        let Playon = null;

        if (playedFrame > jsonTotaltime) {
          while (true) {
            let start = playedFrame - jsonTotaltime;
            if (start < jsonTotaltime) {
              Playon = start;
              break;
            } else {
              playedFrame = start;
            }
          }
        } else {
          Playon = playedFrame;
        }
        AnimationData.goToAndStop(Playon, true, value.AnimationId);
      }
    }
  }, [TickerPosition]);

  useEffect(() => {
    if (!CanvasDisplay) {
      if (played) AnimationData.stop(value.AnimationId);
    }
  }, [CanvasDisplay]);

  useEffect(() => {
    if (value.player) {
      if (played) {
        let playedtime = TickerPosition - value.startPositionOnTimeline; //in px
        let jsonTotaltime = AnimationData.totalFrames;
        let fm = AnimationData.frameRate;
        let ms = (playedtime * onePxEquivalent) / 1000;
        let playedFrame = ms * fm;
        let Playon = null;

        if (playedFrame > jsonTotaltime) {
          while (true) {
            let start = playedFrame - jsonTotaltime;
            if (start < jsonTotaltime) {
              Playon = start;
              break;
            } else {
              playedFrame = start;
            }
          }
        } else {
          Playon = playedFrame;
        }
        if (Playon <= 0) {
          Playon = 0;
        }
        AnimationData.goToAndPlay(Playon, true, value.AnimationId);
      }
    } else if (!value.player) {
      if (played) {
        AnimationData.stop(value.AnimationId);
      }
    }
  }, [value.player]);

  return (
    <>
      <div
        className={""}
        draggable="false"
        style={{
          //transform:(!CanvasDisplay ? `rotate(${value.rotateAngle}deg) ` + value.flip : value.flip),
          width: "100%",
          height: "100%",
          position: "absolute",
          top: "0px",
          zIndex: -1,
        }}
      >
        <canvas
          ref={AnimationRef}
          className={"propCan "}
          width={value.width}
          height={value.height}
        />
      </div>
    </>
  );
};
export default PandS_loader;
